import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTaskById = async (id, authToken) => {
    if (!authToken) return null;
    const response = await authFetch(`${API_URL}/api/task/${id}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) throw new Error('Failed to fetch task');
    return await response.json();
};

export const fetchTodo = async (authToken) => {

    if (!authToken) return [];

    try {
        const response = await authFetch(`${API_URL}/api/tasks`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) throw new Error('Failed to fetch todos');

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const deleteTodo = async (id, authToken) => {
    if (!authToken) return [];
    try {
        const response = await authFetch(`${API_URL}/api/task/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) throw new Error('Failed to delete task');

        // await queryClient.invalidateQueries({queryKey: ['todo']})
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const handleSaveTask = async (task, authToken) => {
    const normalizedDeadline = task?.deadline ? new Date(task.deadline).getTime() : null;
    const rawProjectId = task?.projectId;
    const normalizedProjectId = (() => {
        if (rawProjectId == null || rawProjectId === '') return null;
        const asNumber = Number(rawProjectId);
        return Number.isNaN(asNumber) ? rawProjectId : asNumber;
    })();

    const jsonTask = JSON.stringify({
        text: task.title ?? task,
        created_date: normalizedDeadline,
        deadline_date: normalizedDeadline,
        repeat: task.repeat ?? false,
        priority: task.priority ?? null,
        project: normalizedProjectId,
    });

    await authFetch(`${API_URL}/api/task`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authToken}`,
        },
        body: jsonTask
    })
}

export const handleUpdateTask = async (id, task, authToken) => {
    const normalizedDeadline = task?.deadline ? new Date(task.deadline).getTime() : null;
    const rawProjectId = task?.projectId;
    const normalizedProjectId = (() => {
        if (rawProjectId == null || rawProjectId === '') return null;
        const asNumber = Number(rawProjectId);
        return Number.isNaN(asNumber) ? rawProjectId : asNumber;
    })();

    const jsonTask = JSON.stringify({
        text: task.title,
        deadline_date: normalizedDeadline,
        repeat: task.repeat ?? false,
        priority: task.priority ?? null,
        project: normalizedProjectId,
    });

    const response = await authFetch(`${API_URL}/api/task/${id}/details`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${authToken}`,
        },
        body: jsonTask,
    });

    if (!response.ok) {
        throw new Error('Failed to update task');
    }

    return await response.json();
}

